import type { GuardListItem } from '../types';
import StatusBadge from './StatusBadge';
import { toGGScore, getScoreColor, getScoreColorClass } from '../utils/score';

interface GuardCardProps {
  guard: GuardListItem;
  onClick: () => void;
}

export default function GuardCard({ guard, onClick }: GuardCardProps) {
  const initials = `${guard.first_name?.[0] ?? ''}${guard.last_name?.[0] ?? ''}`.toUpperCase();
  const ggScore = toGGScore(guard.score);
  const colorClass = getScoreColorClass(getScoreColor(guard.score));

  return (
    <button
      onClick={onClick}
      className="text-left w-full rounded-2xl border border-slate-100 bg-white p-5 hover:shadow-md transition-shadow"
    >
      <div className="flex items-start gap-4">
        <div className="w-12 h-12 rounded-full bg-gradient-to-br from-blue-400 to-cyan-400 flex items-center justify-center flex-shrink-0">
          <span className="text-base font-bold text-white">{initials}</span>
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-sm font-semibold text-slate-900 truncate">{guard.name}</h3>
          <p className="text-xs text-slate-400 mt-0.5">
            {guard.assigned_sites_count} site{guard.assigned_sites_count !== 1 ? 's' : ''} assigned
          </p>
        </div>
        <span className={`text-xl font-bold ${colorClass}`}>{ggScore}</span>
      </div>
      <div className="mt-4 flex items-center justify-between">
        <StatusBadge
          label={guard.is_active ? 'Active' : 'Inactive'}
          variant={guard.is_active ? 'success' : 'neutral'}
        />
        <span className="text-xs text-slate-400">
          Added {new Date(guard.created_at).toLocaleDateString()}
        </span>
      </div>
    </button>
  );
}
